var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 64,
    viewBox: "0 0 90 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.194 28.8806C71.194 44.8309 58.2637 57.7612 42.3134 57.7612C26.3631 57.7612 13.4328 44.8309 13.4328 28.8806C13.4328 12.9303 26.3631 0 42.3134 0C58.2637 0 71.194 12.9303 71.194 28.8806Z",
    fill: "#E92127"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73134 41.9776C8.73134 44.3887 6.77677 46.3433 4.36567 46.3433C1.95458 46.3433 0 44.3887 0 41.9776C0 39.5665 1.95458 37.6119 4.36567 37.6119C6.77677 37.6119 8.73134 39.5665 8.73134 41.9776Z",
    fill: "#E92127"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56.4179C90 60.4982 86.6923 63.806 82.6119 63.806C78.5316 63.806 75.2239 60.4982 75.2239 56.4179C75.2239 52.3376 78.5316 49.0299 82.6119 49.0299C86.6923 49.0299 90 52.3376 90 56.4179Z",
    fill: "#E92127"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4563 20.9725C74.4563 20.2307 73.8549 19.6293 73.113 19.6293H42.4094C41.6675 19.6293 41.0661 20.2307 41.0661 20.9725V45.5677L42.7632 44.3359C43.9349 43.4855 45.3387 43.0284 46.7786 43.0284H73.113C73.8549 43.0284 74.4563 42.427 74.4563 41.6851V20.9725ZM44.7709 47.192C45.3567 46.7668 46.0587 46.5383 46.7786 46.5383H74.4563C76.364 46.5383 77.9104 44.9668 77.9104 43.0284V19.6293C77.9104 17.6908 76.364 16.1194 74.4563 16.1194H41.0661C39.1584 16.1194 37.6119 17.6908 37.6119 19.6293V52.388L44.7709 47.192Z",
    fill: "#1C1B1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7612 30.8955L57.7612 38.9552",
    stroke: "#1C1B1F",
    strokeWidth: 4.02985,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7612 24.1791L57.7612 24.8507",
    stroke: "#1C1B1F",
    strokeWidth: 4.02985,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.a4e3de13c477bebe26fc8516501ba96e.svg";
export { ForwardRef as ReactComponent };